/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "UykTYYgArbc",
    title: "Chadar Frozen River Trek",
    description:
      "The Ladakh region offers some exceptional topography one of them is the blue Zanskar freezing in time. Walking on this ice Chadar is the adventure of a lifetime.",
    creator: "TrekThe Himalayas",
    views: "744K",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/UykTYYgArbc/0.jpg",
      alt: "Chadar Trek"
    },
    categoryName: "Trekking",
    mustWatch: true
  },
  {
    _id: "cCRICcY9fWA",
    title: "13 Things For Trekking",
    description:
      "13 things that must always be easily accessible to you while trekking and where to keep them. When we say “easily accessible,” we mean any of these should be available to me by opening just one flap, or unzipping just one zip.",
    creator: "Indiahikes",
    views: "149K",
    uploaded: "2 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/cCRICcY9fWA/0.jpg",
      alt: "13 Things For Trekking"
    },
    categoryName: "Trekking"
  },
  {
    _id: "qGGlXr0xKpQ",
    title: "Kuari Pass Beautiful Trek",
    description:
      "Trek amidst the peaks like Nanda Devi, Dronagiri, Kamet, etc.",
    creator: "Radhika Nomllers",
    views: "207K",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/qGGlXr0xKpQ/0.jpg",
      alt: "Kuari Pass"
    },
    categoryName: "Trekking"
  },
  {
    _id: "oM_9lF4u4_o",
    title: "Sonprayag to Kedarnath Trekking",
    description:
      "This is the 3rd episode of Kedarnath yatra (Travel series), we have done 16 km trekking from Gaurikund to Kedarnath temple.",
    creator: "Naveen Rawat",
    views: "4.5M",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/oM_9lF4u4_o/0.jpg",
      alt: "Sonprayag to Kedarnath Temple Trekking"
    },
    categoryName: "Trekking"
  },
  {
    _id: "cTxPiPyNrgU",
    title: "Kerala's best beaches in Varkala!",
    description:
      "Kerala is one of the most beautiful states in India for traveling and a road trip.",
    creator: "Tanya Khanijow",
    views: "2.2M",
    uploaded: "10 months",
    thumbnail: {
      src: "https://img.youtube.com/vi/cTxPiPyNrgU/0.jpg",
      alt: "Kerala's best beaches in Varkala!"
    },
    categoryName: "Beaches",
    mustWatch: true
  },
  {
    _id: "70WgbWEF3Tk",
    title: "Myrtle Beach Vacation Guide",
    description:
      "Myrtle Beach – This jewel in the string of seaside towns that make up the Grand Strand offers its own spin on South Carolina’s coastal charm.",
    creator: "Expedia",
    views: "285K",
    uploaded: "2 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/70WgbWEF3Tk/0.jpg",
      alt: "Myrtle Beach Vacation"
    },
    categoryName: "Beaches"
  },
  {
    _id: "8hufFR1OP8o",
    title: "Packing For My Beach Vacation!",
    description:
      "Hey dumdums I can't even begin to describe how excited I am for this trip. Here's me packing for my trip!",
    creator: "MostlySane",
    views: "1M",
    uploaded: "4 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/8hufFR1OP8o/0.jpg",
      alt: "Packing For My Beach Vacation!"
    },
    categoryName: "Beaches"
  },
  {
    _id: "uA_H2NUakp0",
    title: "Top 10 Indian Beaches",
    description:
      "Best 10 Beaches of India. No need to visit Bali, Maldives and Mauritius when we have more beautiful Beaches in India itself. Vocal for Local and visit Indian Beaches. We have made a list of top 10 beaches of India.",
    creator: "TripsCart",
    views: "112K",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/uA_H2NUakp0/0.jpg",
      alt: "Top 10 Indian Beaches"
    },
    categoryName: "Beaches"
  },
  {
    _id: "ltT6a7dM7RU",
    title: "Kodaikanal Travel video",
    description:
      "Mannavanur lake which is almost 40 kms from the city. The place looks heavenly and is very beautiful.",
    creator: "Hopping Bug",
    views: "1.1M",
    uploaded: "3 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/ltT6a7dM7RU/0.jpg",
      alt: "Kodaikanal Travel video"
    },
    categoryName: "Hill Station",
    mustWatch: true
  },
  {
    _id: "eAEjFfjO9gg",
    title: "Mussoorie Hill Station",
    description:
      "Mussoorie (Garhwali/Hindi: Masūrī) is a hill station and a municipal board in the Dehradun District of the northern Indian state of Uttarakhand.",
    creator: "IndiaTravelVideos",
    views: "2.8M",
    uploaded: "3 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/eAEjFfjO9gg/0.jpg",
      alt: "Mussoorie Hill Station"
    },
    categoryName: "Hill Station"
  },
  {
    _id: "C690MLb3fho",
    title: "OOTY Tour Guide",
    description:
      "OOTY TOUR GUIDE | Budget Tour Plan Ooty | 2 days Ooty Plan | Ooty Hill Station",
    creator: "Yatra Vats",
    views: "266K",
    uploaded: "7 months",
    thumbnail: {
      src: "https://img.youtube.com/vi/C690MLb3fho/0.jpg",
      alt: "OOTY Tour"
    },
    categoryName: "Hill Station"
  },
  {
    _id: "hOqt32zlFas",
    title: "Top 10 Best Hill Stations in India",
    description:
      "India is a very beautiful country and it is famous for his natures. Here you will find one of the best hill stations  with Highest altitude, Coldest and Lansdown in any month. Some of the Hill station are very good in May and June Month as well.",
    creator: "Anis Khan",
    views: "4M",
    uploaded: "5 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/hOqt32zlFas/0.jpg",
      alt: "Top 10 Best Hill Stations in India"
    },
    categoryName: "Hill Station"
  },
  {
    _id: "AfDWRh_tE4c",
    title: "Top 10 National Parks of India",
    description:
      "In this video we will talk about the top 10 national parks of India.",
    creator: "JUNGLE SAFARI",
    views: "52K",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/AfDWRh_tE4c/0.jpg",
      alt: "Top 10 National Parks of India"
    },
    categoryName: "Jungle Safari"
  },
  {
    _id: "VTnhIwRNO_s",
    title: "Gir National Park",
    description:
      "This video is from Gir National Park & Sanctuary, in Sasan Gir, Gujarat, India. To keep the momentum up we decided to say Hello to Indian SIMBA !",
    creator: "Savvy Fernweh",
    views: "356K",
    uploaded: "2 years",
    thumbnail: {
      src: "https://img.youtube.com/vi/VTnhIwRNO_s/0.jpg",
      alt: "Gir National Park"
    },
    categoryName: "Jungle Safari"
  },
  {
    _id: "qwd5TCR-b8Y",
    title: "Jungle Safari Bandhavgarh",
    description:
      "Bandhavgarh National Park is in the central Indian state of Madhya Pradesh. This biodiverse park is known for its large population of royal Bengal tigers, especially in the central Tala zone. Other animals include white tigers, leopards and deer. The mix of tropical forest, Sal trees and grassland is home to scores of bird species, including eagles. To the south are the remains of the ancient Bandhavgarh Fort.",
    creator: "gkdiscovery",
    views: "571K",
    uploaded: "1 year",
    thumbnail: {
      src: "https://img.youtube.com/vi/qwd5TCR-b8Y/0.jpg",
      alt: "Jungle Safari Bandhavgarh"
    },
    categoryName: "Jungle Safari"
  },
  {
    _id: "vrea81xqSHM",
    title: "Jim Corbett National Park",
    description:
      "Experience close encounter with tiger and 3 times glimpse in single safari. How to book stay in Dhikala zone and Jim Corbett national park. How to plan trip to Jim Corbett and important tips to consider before and during the trip.",
    creator: "Bharat Blog",
    views: "260K",
    uploaded: "4 months",
    thumbnail: {
      src: "https://img.youtube.com/vi/vrea81xqSHM/0.jpg",
      alt: "Jim Corbett National Park"
    },
    categoryName: "Jungle Safari"
  }
];
